import { ActivatableTransportType } from './activatable-transport-type.enum';

export class ActivateTransportDetails {

  transportIds: number[];
  type: ActivatableTransportType;
}
